export default __webpack_public_path__ + "static/media/item_management.337963a0.png";